import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import SubCategoryCreationSchema from "../../../../Schemas/SubCategoryCreationSchema";

import { createSubCategory, updateSubCategory, getSubCategorysByCategory } from "../../../../Services/SubCategoryService";
import { useHistory } from "react-router-dom"; // useHistory for v5

function SubCategoryCreationForm({
  data = {},
  categoryData,
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      code: data.code || "",
      category : data.category || ""
    },
    enableReinitialize: true,
    validationSchema: SubCategoryCreationSchema,
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5

  // Find next available code (1-9) for the selected category
  const findNextAvailableCode = (existingSubCategories) => {
    const usedCodes = new Set(
      existingSubCategories.map((sub) => String(sub.code))
    );

    for (let i = 1; i <= 9; i++) {
      if (!usedCodes.has(String(i))) {
        return String(i);
      }
    }

    return "";
  };

  // Handle category change - autofill code in create mode
  const handleCategoryChange = async (category) => {
    formik.setFieldValue("category", category);

    if (!isEditMode && category) {
      try {
        const response = await getSubCategorysByCategory(category);
        let existingSubCategories = [];

        if (response && response.data) {
          if (Array.isArray(response.data)) {
            existingSubCategories = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            existingSubCategories = response.data.data;
          }
        }

        const nextCode = findNextAvailableCode(existingSubCategories);
        if (nextCode !== "") {
          formik.setFieldValue("code", nextCode);
        }
      } catch (error) {
        console.error("Error fetching subcategories by category:", error);
      }
    }
  };

  const handleSubmit = async () => {
    const values = formik.values;
    if (isEmpty(values.name) || isEmpty(values.code)) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createSubCategory(values);
        message.success("SubCategory created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the subcategory list or wherever you want
      } else {
        const updatedSubCategory = await updateSubCategory(data._id, values);
        callReFetch();
        message.success(
          updatedSubCategory?.data?.message || "SubCategory updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const { values } = formik;
  const titleText = isEditMode ? "SubCategory Detail" : "Create SubCategory";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & Code Tidak boleh duplicate
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            width: "80vw",
            backgroundColor: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter subcategory name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Category" required>
            <Select
              style={{ width: "100%" }}
              placeholder="Select a category"
              onChange={handleCategoryChange}
              value={values.category}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {categoryData.map((category) => (
                <Select.Option key={category.name} value={category.name}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Code" required>
            <Input
              name="code"
              placeholder="Enter brand code"
              maxLength={1} // Restrict input length to 1 character
              onChange={(e) => {
                const value = e.target.value;
                if (/^[0-9]?$/.test(value)) {
                  formik.setFieldValue("code", value); // Only allow 0-9 as a string
                }
              }}
              value={formik.values.code}
            />
          </Form.Item>{" "}
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

SubCategoryCreationForm.propTypes = {};

export default SubCategoryCreationForm;
